export default {
  header: {
    language: 'EN',
    languageMb: 'EN',
    logout: "LOG OUT",
    rule: "RULE",
    viewRule: "VIEW RULE",
    shrinkMenuName: 'CATEGORY',
    size:'SIZE'
  },
  countdown: {
    begintime:'{name} will begin on',
    countDownText:"The countdown of {name} ",
    countDown:"Countdown"
  },
  end: {
    end:"Activity has ended.",
    order:"My Order"
  },
  common: {
    "0":{
      symbol: '{value}pt',
    },
    "1":{
      symbol: 'HK${value}',
    },
    "2":{
      symbol: 'HK${value}',
    },
    buyconfirm: "",
    confirmOrder: "Confirm Order",
    confirm: "Confirm",
    cancel: "Cancel",
    back: "Back",
    agreement:'Terms and Conditions',
    rule: 'Terms and Conditions',
    ruleTitle: 'T&C',
    warning:"Warning",
    pt:"Point",
    remainAmount:"Amount",
    agree:"Agree"
  },
  index: {
    empty: "No available event !"
  },
  login: {
    userName: 'userName',
    nameTip: 'Please input user name',
    password: 'password',
    passwordTip: 'Please input user password',
    login: 'Login'
  },
  footer: {
    activity: 'Activity',
    classify: 'Category',
    cart: "Cart",
    my: 'My Profile'
  },
  goods: {
    specification: 'Specs',
    selectModel: 'selectModel',
    quantity: 'Qty',
    productDetails: 'Product Details',
    addCart: 'Add To Cart',
    buy: 'Buy',
    stock: 'Stock',
    exchange: "Redeem",
    minQuota: "Quota",
    sellOut: "Sold Out",
    productPrice: "Price",
    notFound: "Sorry, no related products were found~",
  },
  screen: {
    classify: 'classify',
    sort: 'sort',
    all: 'all',
    sortOne: 'Prices range from high to low',
    sortTwo: 'Prices range from low to high'
  },
  order: {
    cancelTip:"Are you sure to cancel this order?",
    empty:"No orders.",
    empty2:"No such orders.",
    myOrder: 'Orders',
    allOrder: 'All',
    noPayment: 'Unpaid',
    havePaid: 'Paid',
    shipped: 'Shipped',
    isAll: '',
    variable: ' Piece(s)',
    total: 'Total',
    subtotal:"Subtotal",
    cancelOrder: 'Cancel',
    cancelOrder1: 'Cancel Order',
    cancelSuccess:"The order has been cancelled successfully!",
    cancelFailed:"Failed, Please retry!",
    cancelBuy: 'Cancel',
    pay: 'Pay',
    orderStatus: 'Order Status',
    consignee: 'Consignee',
    orderTime: 'Order Date',
    payTime: 'Pay Date',
    orderNumber: 'Order No.',
    canceled: "Cancelled",
    allOrders: "All Orders",
    orderDetail: "Order Details",
    telephone: "Telephone",
    transactionNo: "Transaction No.",
    paymentMethod: "Payment Method",
    address: "Pick Up",
    realPayment: "Actual Price",
    exportOrder: "Export Order",
    downloadInvoice: "Download Invoice",
    wechatPay:"WeChat Pay",
    pointPay:"Redeem by Point",
    pointPay1:"Point",
    outOfStock:"Out of stock items",
    confirmOrderExpire: "Please finish your payment before {expire}.",
    downloadVoiceConfirm: "Please download the invoice used for pick up!",
    affirm: "Confirm",
    cancel: "Cancel"
  },
  cart: {
    selected1:"Selected ",
    yourPoint:"You Have ",
    yourAmount:"Your Remain Amount ",
    empty:"Cart Empty",
    confirmDelete: "Are you sure to remove this item from the shopping cart?",
    buy: "Buy",
    tip: 'Warning',
    confirm:"Confirm",
    deleteTip: 'Are you sure to remove this item from the shopping cart?',
    cancel: 'Cancel',
    affirm: 'Submit',
    isAll: 'Select All',
    settlement: 'Submit',
    selectNote: "Please select some items !",
    confirmOrder: "Once you submit a order, the order can no longer been canceled or modified. Are you sure to submit the ord",//"Each person can only submit {orderQty} order. Once you pay a order, the order can no longer been canceled or modified. Are you sure to submit the order?",
    continue: "Continue shopping",
    goHome: "Go shopping",
    delete: "Delete",
    selected: "{orderQty} Piece(s)"
  },
  global: {
    orderConfirm: "Please Confirm before Placing The Order",
    total: "Total",
    instant: "Confirm",
    spec: "Specification",
    model: "Model",
    noData: "No Data"
  },
  placeorder: {
    success: "Success！",
    lack: "One or more items in your order is now out of stock, we are adding rest of them to the order...",
    lackall: "All items in your order are now out of stock！",
    retry: "Oops！ Something went wrong, please retry!",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "You have reached the limit of some product!",
    globalqty: "You cannot buy any more products!",
    typeqty: "You have reached the limit of category!",
    catqty: "You have reached the limit of category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!"
  },
  cartMsg: {
    success: "Product has been successfully added to the shopping cart",
    lackall: "This item is now out of stock！",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "You have reached the limit of this product!",
    globalqty: "You cannot buy any more products!",
    typeqty: "You have reached the limit of this type!",
    catqty: "You have reached the limit of this category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!",
    0: "Product has been successfully added to the shopping cart",
    2: "This item is now out of stock！",
    3: "This item is now out of stock！",
    4: "This campaign has reach the limit of total amount!",
    5: "You have reached the limit of this product!",
    6: "You cannot buy any more products!",
    7: "You have reached the limit of this type!",
    8: "You have reached the limit of this category!",
    9: "You cannot place any more order!",
    10: "You don't have enough point!",
    11: "You have reached your amount limit!",
    12: "You remain amount is not enough!",
    retry: "Oops！ Something went wrong, please retry!",
  },
  session: {
    end: "This campaign is already finished.",
    start: "This campaign is not start yet.",
    text: "COUNTDOWN",
    countdown: "{days} Day(s) {hours}:{minutes}:{seconds}",
  },
  search: {
    info: "Please input keyword to search.",
    notfound: "Oops, we cannot find anything related to “{searchKeyWord}”",
    placeholder: "Search",
    history:"Search History"
  }
}




// WEBPACK FOOTER //
// ./src/locales/en.js